import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            d="M10.08 9.856h4.215c.393 0 .69.276.705.652a.692.692 0 0 1-.647.718c-.436.02-.873.018-1.31.013-.247-.003-.252-.002-.164.228a2.58 2.58 0 0 1-1.34 3.268 2.746 2.746 0 0 1-1.13.253c-.483.008-.97.023-1.452 0-1.31-.067-2.305-.98-2.502-2.167a2.412 2.412 0 0 1-.035-.466.673.673 0 0 1 .677-.648c.36.002.656.29.676.654.038.714.533 1.209 1.255 1.23.51.015 1.02.01 1.53-.003.44-.013.905-.4 1.045-.838a1.2 1.2 0 0 0-.374-1.275 1.052 1.052 0 0 0-.697-.236c-1.532.006-3.062.006-4.594 0-.175 0-.359-.027-.523-.083-.267-.093-.443-.408-.411-.676.035-.3.281-.574.58-.59.493-.027.988-.028 1.483-.03 1.005-.003 2.01 0 3.015 0l-.002-.004ZM9.731 5c.375.034.863.04 1.335.128 1.132.21 2.096 1.473 1.985 2.552-.03.293-.293.578-.577.627a.663.663 0 0 1-.722-.414c-.062-.152-.084-.321-.118-.484a1.204 1.204 0 0 0-1.197-.98c-.452-.004-.905-.012-1.357.002-.513.015-.912.24-1.14.707-.226.47-.221.93.122 1.352.177.218.256.445.15.725a.668.668 0 0 1-1.098.246 2.393 2.393 0 0 1-.625-1.142c-.368-1.477.63-2.984 2.144-3.229.326-.052.659-.055 1.098-.09Z"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
